import React from 'react'
import { LABELS } from '../constants/staticText'
import selectEvents from '../functions/selectEvents'
import useLoad from '../functions/useLoad'
import { loadEvents } from '../apis/publicApi'
import EventCard from './EventCard'
import PlainLink from './PlainLink'
import EventSkeleton from './EventSkeleton'

// Kachelreihe für den Shortcode (#24): nur die Events, keine Sidebar und keine
// Status-Gruppen. Welche Kategorien gezeigt werden, entscheidet der Shortcode.
// Die Kachel ist dieselbe wie in der Übersicht, sie bekommt den passenden
// Verweis herein (#107) — PlainLink, weil die Startseite nicht zum Router der
// Event-App gehört.

// Platzhalter fuer eine volle Kachelzeile (fuenf auf breiten Schirmen), mit
// limit hoechstens so viele wie Kacheln kommen koennen. Sie halten die Hoehe
// der Reihe, damit der Inhalt unter dem Shortcode beim Laden nicht springt.
const PLATZHALTER = 5

const EventsShortcode = ({ title, status, limit }) => {
    const { data, loading, error } = useLoad(loadEvents, [])
    const events = selectEvents(data, { status, limit })

    return (
        <section className="events-shortcode">
            {title && <h2 className="events-section-title">{title}</h2>}

            {loading && <EventSkeleton variant="cards" count={Math.min(limit || PLATZHALTER, PLATZHALTER)} label={LABELS.loadingEvents} />}
            {error && <p className="events-state">{LABELS.error}</p>}
            {data && 0 === events.length && <p className="events-state">{LABELS.empty}</p>}

            <ul className="events-cards">
                {events.map(event => <EventCard key={event.slug} event={event} LinkComponent={PlainLink} />)}
            </ul>
        </section>
    )
}

export default EventsShortcode
